<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">เลือกสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <v-card elevation="4" style="border-radius: 15px;">
            <v-card-title>
              <v-row>
                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                  <v-btn type="button" :class="selected.length > 0 ? 'btn_add_data_select' : 'btn_add_data_disable'"
                    @click="product_add(selected.length);" large>บันทึกสินค้าที่เลือก</v-btn>
                  <v-btn class="ml-2 btn_add_data_select" type="button" @click="product_add_all();" large>นำเข้ารายการสินค้าทั้งหมด</v-btn>
                </v-col>
                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12"></v-col>
                <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                  <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto"
                    required v-model="search" placeholder="ค้นหา..." single-line outlined dense></v-text-field>
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text>
              <v-data-table show-select v-model="selected" :headers="headers" :items="productList" :search="search"
                :footer-props="footer_Props" mobile-breakpoint="0" fixed-header>
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td class="hidden_line"><v-checkbox color="#D6BFAF" v-model="selected" :value="item" /></td>
                      <td class="hidden_line">
                        <div>{{ item.product_code }}</div>
                      </td>
                      <td class="hidden_line">
                        <div>{{ item.name }}</div>
                      </td>
                      <td class="hidden_line">
                        <div>{{ item.name_sci }}</div>
                      </td>
                      <td class="hidden_line">
                        <v-btn elevation="3" class="ma-2" outlined color="#8EBBDC" title="ดูรายละเอียด" height="45" small
                          style="border-radius:10px" @click="detail_product(item.id);">
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="product_modal" persistent max-width="784">
        <v-card class="pa-3">
          <div class="d-flex justify-space-between">
            <v-card-title>
              รายละเอียดสินค้า
            </v-card-title>
            <v-btn icon class="ma-4" @click="product_modal = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <div class="text-left content_header">ข้อมูลสินค้า</div>
            <div class="my-2">
              <v-img height="160" max-width="160" :lazy-src="img_product" :src="img_product" class="preview"></v-img>
            </div>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <div class="content_text">ชื่อสินค้า :
                  <span style="font-weight: 600;">{{ productDetailFirstArray.name }}</span>
                </div>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <div class="content_text">ชื่อทางการแพทย์ : <span style="font-weight: 600;">{{
                  productDetailFirstArray.name_sci }}</span></div>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <div class="content_text">รายละเอียด :
                  <span style="font-weight: 600;">{{ productDetailFirstArray.detail }}</span>
                </div>
              </v-col>
            </v-row>
            <div class="mt-5">
              <v-data-table :headers="header_modal" :items="productDetail" :footer-props="footer_Props"
                mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td class="hidden_line">
                      <div>{{ dataDetail.item.unit_name }}</div>
                    </td>
                    <td class="hidden_line">
                      <div>{{ dataDetail.item.barcode }}</div>
                    </td>
                    <td class="hidden_line">
                      <div>{{ dataDetail.item.retail_price }}</div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="product_modal_add" persistent max-width="353" max-height="313">
        <v-card>
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>ยืนยันการบันทึกสินค้าที่เลือก</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="product_modal_add = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <center>
                  <v-img height="90" max-width="90" :lazy-src="img_approved" :src="img_approved"
                    class=" mt-3 mb-2"></v-img>
                </center>
              </v-col>
              <v-col cols="12" class="text-center">
                <h3>คุณต้องการบันทึกสินค้าที่เลือกใช่หรือไม่</h3>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="button" @click="productSave();" class="btn_confirm_data" large>ยืนยัน</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- นำเข้าทั้งหมด -->
      <v-dialog v-model="product_modal_add_all" persistent max-width="353" max-height="313">
        <v-card>
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>ยืนยันการบันทึกสินค้าทั้งหมด</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="product_modal_add_all = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <center>
                  <v-img height="90" max-width="90" :lazy-src="img_approved" :src="img_approved"
                    class=" mt-3 mb-2"></v-img>
                </center>
              </v-col>
              <v-col cols="12" class="text-center">
                <h3>คุณต้องการบันทึกสินค้าทั้งหมดใช่หรือไม่</h3>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="button" @click="productSaveAll();" class="btn_confirm_data" large>ยืนยัน</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import img_approved from "@/assets/arin_assets/approve.png";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
export default {
  name: "Pos_choose_product",
  data() {
    return {
      loading_page: true,
      product_modal: false,
      product_modal_add: false,
      img_approved: img_approved,
      search: '',
      selected: [],
      productList: [],
      productDetail: [],
      img_product: null,
      productDetailFirstArray: [],
      product_modal_add_all:false,
      phamacare_product:
      {
        id: [],
        product_pharma_status: 0
      }
      ,
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'รายการสินค้า',
          disabled: false,
        },
        {
          text: 'เลือกสินค้า',
          disabled: false,
          href: '#',
        },
      ],
      headers: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '130px',
          sortable: false,
          align: 'left',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
          width: '250px',
          sortable: false,
          align: 'left',
        },
        {
          text: 'ชื่อทางการแพทย์',
          value: 'name_sci',
          fixed: true,
          width: '200px',
          sortable: false,
          align: 'left',
        },
        {
          text: 'ดูรายละเอียด',
          value: '',
          fixed: true,
          width: '200px',
          sortable: false,
          align: 'left',
        },
      ],

      header_modal: [
        {
          text: 'หน่วยนับ',
          value: '',
          fixed: true,
          align: 'left',
        },
        {
          text: 'บาร์โค๊ด',
          value: '',
          fixed: true,
          align: 'left',
        },
        {
          text: 'ราคาขายปลีก',
          value: '',
          fixed: true,
          align: 'left',
        },
      ],
      data_modal: [
        { id: 1, unit_name: 'แผง', barcode: '8851447010013', price: '100' },
        { id: 2, unit_name: 'BX(10)', barcode: '8851447010013', price: '1000' },
      ],
    }
  },
  methods: {
    // GET ข้อมูลสินค้าจาก ฟาร์มา
    getProductList() {
      this.loading_page = true
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/product/productlist', config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.productList = res.data.productList;
        }
      })
    },
    detail_product(id) {
      this.loading_page = true
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/product/detail/' + id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.productDetail = res.data.productDetail;
          this.productDetailFirstArray = res.data.productDetail[0];
          this.img_product = 'http://178.128.23.117/uploads/images/' + res.data.productDetail[0].picture;
        }
      })
      this.product_modal = true
    },
    product_add(chkItems) {
      if (chkItems > 0) {
        this.product_modal_add = true
      }
    },
    product_add_all() {
      this.product_modal_add_all = true
    },
    productSave() {
      
      let getID = this.selected.map(detail => { return detail.id });
      this.phamacare_product.id = getID;
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      this.loading_page = true
      // ส่งไปเพิ่ม
      HTTP_ARIN.post('/product/addproducts', this.phamacare_product, config)
        .then((res) => {
          if (res.data.successful === true) {
            this.loading_page = false
            let timerInterval
            Swal.fire({
              title: 'เสร็จสิ้น',
              text: 'เพิ่มข้อมูลเรียบร้อยแล้ว',
              icon: 'success',
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading()
                timerInterval = setInterval(() => { }, 100)
              },
              willClose: () => {
                clearInterval(timerInterval)
                setTimeout(function () {
                  window.location.href = '/arin/pos/warehouseproductlist';
                });
              }
            })
          }
          else {
            this.loading_page = false
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
    },
    productSaveAll() {
      let getID = this.productList.map(detail => { return detail.id });
      this.phamacare_product.id = getID;
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      this.loading_page = true
      HTTP_ARIN.post('/product/addproducts', this.phamacare_product, config)
        .then((res) => {
          if (res.data.successful === true) {
            this.loading_page = false
            let timerInterval
            Swal.fire({
              title: 'เสร็จสิ้น',
              text: 'เพิ่มข้อมูลเรียบร้อยแล้ว',
              icon: 'success',
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading()
                timerInterval = setInterval(() => { }, 100)
              },
              willClose: () => {
                clearInterval(timerInterval)
                setTimeout(function () {
                  window.location.href = '/arin/pos/warehouseproductlist';
                });
              }
            })
          }
          else {
            this.loading_page = false
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
    }
  },
  mounted() {
    this.getProductList();
  }
}
</script>

<style scoped>
.btn_add_data_select {
  font-size: 16px;
  color: #FFF !important;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
}

.btn_add_data_disable {
  font-size: 16px;
  color: #FFF !important;
  background: linear-gradient(90deg, #616161 0%, rgba(173, 173, 173, 0) 100%), #ADADAD !important;
  border-radius: 10px;
}

.btn_confirm_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.preview {
  border-radius: 10px;
}

.content_header {
  font-weight: 600;
  font-size: 16px;
  color: #616A6B;
}

.content_text {
  font-weight: 500;
  font-size: 16px;
  color: #909090;
}

.sub_content_text {
  font-weight: 500;
  font-size: 16px;
  color: #616A6B;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
</style>
